export enum ReportStatus {
    DRAFT = 'DRAFT',
    NOT_VERIFIED = 'NOT_VERIFIED',
    OPEN = 'OPEN',
}
